import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import StickyCTA from '../../components/feature/StickyCTA';
import DiagnosisForm from './components/DiagnosisForm';

export default function Diagnosis() {
  return (
    <>
      <Header />
      <main className="min-h-screen bg-gradient-to-br from-[#02D0F0] to-[#07DBCA] py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              旅行タイプ診断
            </h1>
            <p className="text-xl opacity-90 max-w-2xl mx-auto">
              16の質問に答えて、あなたにぴったりの旅行スタイルを発見しましょう
            </p>
          </div>
          <DiagnosisForm />
        </div>
      </main>
      <Footer />
      <StickyCTA />
    </>
  );
}
